const React = require("react");
const Ripple = require("../../../../../../../dumb/Ripple");
const {accountType$} = require("../state");

module.exports = ({id, title, activeTabId, disabled}) => {
  return (
    <Ripple
      className={`
        w170 h45 layoutRow fhaC fvaC mr16 b1 bs bc0 r9 f12 ttU
        bg5B47FF.active bc5B47FF.active cF.active
        o50.disabled:not[.active] bc9b9b9b.disabled:not[.active]
        ${id === activeTabId ? 'active' : ''}
        ${disabled ? 'disabled' : ''}                
      `}
      onClick={() => {
        accountType$.emit(id);
      }}
      disabled={disabled}
    >
      {title}
    </Ripple>
  )
}
